// extracted by mini-css-extract-plugin
module.exports = {"btn":"FloatingEditShapeToggle_btn__7AkTV","done-btn":"FloatingEditShapeToggle_done-btn__plZ1B","btn-treatment-filled":"FloatingEditShapeToggle_btn-treatment-filled__uU_h2"};